// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".notification-bar{position:absolute;background:#fff;right:16px;top:12px;z-index:9999;width:-webkit-fit-content;width:-moz-fit-content;width:fit-content;min-width:350px}.notification-bar .v-alert{margin-bottom:0}.notification-bar .v-alert__content{font-size:14px}", ""]);
// Exports
module.exports = exports;
